export default "__VITE_ASSET__28ba0e80__"